<template>
  <div
    class="overflow-x-auto bg-white dark:bg-dark-surface shadow rounded-lg p-4 transition-colors"
  >
    <table class="min-w-full divide-y divide-gray-200 dark:divide-white/5">
      <thead class="bg-gray-50 dark:bg-dark-input">
        <tr>
          <th
            v-for="col in columns"
            :key="col.field"
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-slate-400 uppercase tracking-wider"
          >
            {{ col.label }}
          </th>
          <th
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-slate-400 uppercase tracking-wider"
          >
            {{ $t("actions") }}
          </th>
        </tr>
      </thead>
      <tbody
        class="bg-white dark:bg-dark-surface divide-y divide-gray-200 dark:divide-white/5"
      >
        <tr
          v-for="(row, index) in data"
          :key="index"
          class="hover:bg-gray-50 dark:hover:bg-white/5 transition-colors duration-150"
        >
          <td
            v-for="col in columns"
            :key="col.field"
            class="px-6 py-4 text-sm text-gray-700 dark:text-slate-300"
          >
            <!-- لو في slot باسم الـ field استخدمه، إلا كده اعرض القيمة العادية -->
            <slot v-if="$slots[col.field]" :name="col.field" :row="row" />
            <span v-else>{{ getValue(row, col.field) }}</span>
          </td>

          <td
            class="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-slate-300"
          >
            <slot name="actions" :row="row" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "BaseDataTable",
  props: {
    columns: { type: Array, required: true },
    data: { type: Array, required: true },
  },
  methods: {
    getValue(obj, path, defaultValue = "—") {
      return path.split(".").reduce((o, p) => {
        return o && o[p] !== undefined ? o[p] : defaultValue;
      }, obj);
    },
  },
};
</script>
